import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CommittedOrder,
  GetCommittedOrderRequest,
} from 'planning-portal-library/src/lib/core/domain';
import { injectEnvironment } from 'planning-portal-library/src/lib/core/environments/environment.token';
import {
  catchError,
  forkJoin,
  map,
  mergeMap,
  Observable,
  reduce,
  share,
} from 'rxjs';
import { CommittedOrdersRepository } from '../../../../core/repositories';
import { BaseGridResponse } from '../../../shared/base-grid.response';
import { BaseRequest } from '../../../shared/base.request';
import { BaseResponse } from '../../../shared/base.response';
import { CommittedOrdersApiUrls } from './committed-order-api-urls';
import { CommittedOrderWebEntity } from './entities/committed-order-web-entity';
import { CommittedOrderWebRepositoryMapper } from './entities/committed-order-web-repository-mapper';

@Injectable({ providedIn: 'root' })
export class CommittedOrderWebRepository extends CommittedOrdersRepository {
  private readonly committedOrderMapper = new CommittedOrderWebRepositoryMapper();
  private readonly environment = injectEnvironment();

  committedOrders: CommittedOrderWebRepository[] = [];

  constructor(private readonly http: HttpClient) {
    super();
  }

  getCommittedOrders(
    request: BaseRequest<GetCommittedOrderRequest>
  ): Observable<BaseGridResponse<CommittedOrder>> {
    const httpMap = this.http
      .post<BaseResponse<BaseGridResponse<CommittedOrderWebEntity>>>(
        `${this.environment.url}${CommittedOrdersApiUrls.GetCommittedOrders}`,
        request.request
      )
      .pipe(share());

    const dataResultMap = httpMap
      .pipe(
        mergeMap((response) => response.result!.data),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(map(this.committedOrderMapper.mapFrom))
      .pipe(
        reduce(
          (items: CommittedOrder[], item: CommittedOrder) => [...items, item],
          []
        )
      );

    const totalRecordsResultMap = httpMap.pipe(
      map((response) => response.result!.totalRecords)
    );

    return forkJoin([dataResultMap, totalRecordsResultMap]).pipe(
      map((input) => {
        const item: BaseGridResponse<CommittedOrder> = {
          data: input[0],
          totalRecords: +input[1],
        };
        return item;
      })
    );
  }
}
